import { Route } from '@angular/router';

import { navGuard } from './guard/nav.guard';
import { authGuard } from './guard/auth.guard';
import {
  PageChangelogComponent,
  PageLoginComponent,
  PageOauth2LandingComponent,
  PagePwdResetComponent,
  PageResetRequestComponent,
} from '@infodata-group/inf-commons-desktop';

export const appRoutes: Route[] = [
  { path: 'login', component: PageLoginComponent },
  { path: 'reset-request', component: PageResetRequestComponent },
  { path: 'reset-password', component: PagePwdResetComponent },
  { path: 'oauth2', component: PageOauth2LandingComponent },
  {
    path: 'init',
    loadComponent: () => import('./page/page-landing/page-landing.component'),
  },
  { path: '', redirectTo: 'changelogs', pathMatch: 'full' },
  {
    path: '',
    loadComponent: () => import('./app.component').then((m) => m.AppComponent),
    canActivate: [authGuard, navGuard],
    children: [
      {
        path: 'changelogs',
        loadComponent: () =>
          import('./page/page-changelogs/page-changelogs.component'),
      },
      {
        path: 'changelogs/:product',
        loadComponent: () =>
          import('./page/page-changelogs/page-changelogs.component'),
      },
      {
        path: 'changelog',
        component: PageChangelogComponent,
      },
    ],
  },
];
